/**
 * @description Проверка валидности имени.
 * @param {string} value
 * @returns {boolean}
 */
export function validateName(value) {
  const pattern = /^[а-яА-ЯёЁ)(\- ]{1,255}$/;
  return pattern.test(value);
}
/**
 * @description Проверка валидности электронного адреса.
 * @param {string} value
 */
export function validateEmail(value) {
  const pattern = /^[^@]+@\w+(\.\w+)+\w$/;
  return pattern.test(value);
}
/**
 * @description Проверка валидности телефонного номера.
 * @param {string} value
 */
export function validatePhoneNumber(value) {
  const pattern = /^(?<prefix>\+?7|8)(?<zone>\d{3})(?<number>\d{7})$/;
  return pattern.test(value);
}
/**
 * @description Проверка валидности номера мед карты.
 * @param {string} value
 */
export function validateMedicalCardNumber(value) {
  const pattern = /^[0-9-—/]+$/;
  return pattern.test(value);
}
/**
 * @description Проверка валидности даты рождения.
 * @param {string} value
 */
export function validateBirthDate(value) {
  const date = new Date(value);
  return date <= new Date();
}
/**
 * @description Проверка валидности названия кабинета.
 * @param {string} value
 * @returns
 */
export function validateCabinetName(value) {
  return value.length > 0 && value.length <= 30;
}
/**
 * @description Проверка валидности названия кабинета.
 * @param {string} value
 * @returns
 */
export function validateUrl32top(value) {
  const pattern = /^https:\/\/([a-z]*.)?32top.kz\/clinics\/[0-9]{1,8}/;
  return pattern.test(value);
}
/**
 * @description Проверка валидности названия компании.
 * @param {string} value
 * @returns
 */
export function companyName(value) {
  return value.length > 3 && value.length <= 225;
}
/**
 * @description Проверка валидности цвета.
 * @param {string} value
 * @returns {boolean}
 */
export function validateColor(value) {
  const pattern = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/;
  return pattern.test(value);
}
/**
 * @description Проверка валидности пароля
 * @param {string} value
 * @returns {boolean}
 */
export function validatePassword(value) {
  const pattern = /^\S{8,225}$/;
  return pattern.test(value);
}
/**
 * @description Проверка валидности кабинета комментария.
 * @param {string} value
 * @returns {boolean}
 */
export function validateCabinetComment(value) {
  // const pattern = /^[—№,.\-a-zA-Z0-9а-яА-ЯёЁ ]{0,100}$/;
  return value.length <= 100;
}
/**
 * @description Проверка валидности полиса.
 * @param {string} value
 * @returns {boolean}
 */
export function validatePolis(value) {
  const pattern = /^[\d]{16}$/u;
  return !value || pattern.test(value);
}
/**
 * @description Проверка валидности кода льготы.
 * @param {string} value
 * @returns {boolean}
 */
export function validatePrivilegesCode(value) {
  const pattern = /^[\d]{1,3}/u;
  return !value || pattern.test(value);
}
/**
 * @description Проверка валидности СНИЛСа.
 * @param {string} value
 * @returns {boolean}
 */
export function validateSnils(value) {
  const pattern = /^([\d]{3}-){2}[\d]{3} [\d]{2}$/u;
  return !value || pattern.test(value);
}
/**
 * @description Проверка валидности серии паспорта.
 * @param {string} value
 * @returns {boolean}
 */
export function validatePassportSerial(value) {
  const pattern = /^[\d]{2} [\d]{2}$/u;
  return !value || pattern.test(value);
}
/**
 * @description Проверка валидности серии свидетельства о рождении.
 * @param {string} value
 * @returns {boolean}
 */
export function validateBirthCertificateSerial(value) {
  return value.length <= 7;
}
/**
 * @description Проверка валидности номера.
 * @param {string} value
 * @returns {boolean}
 */
export function validateIdentificationNumber(value) {
  const pattern = /^[\d]{6}$/u;
  return !value || pattern.test(value);
}
/**
 * @description Проверка валидности номера организации.
 * @param {string} value
 * @returns {boolean}
 */
export function validateOrganizationCode(value) {
  const pattern = /^[\d\-—]{0,20}$/;
  return pattern.test(value);
}
/**
 * @description Проверка валидности наименования услуги.
 * @param {string} value
 * @returns {boolean}
 */
export function validateServiceName(value) {
  return value.length >= 3 && value.length <= 255;
}
/**
 * @description Проверка валидности единиц измерений услуги.
 * @param {string} value
 * @returns {boolean}
 */
export function validateServiceUnits(value) {
  return value.length <= 50;
}
/*
 * @description Проверка валидности юр. лица.
 * @param {string} value
 * @returns {boolean}
 */
export function validateLegalName(value) {
  const min = 3;
  const max = 225;
  return value.length >= min && value.length <= max;
}
